import { withRBAC } from "../../rbac";
import { DesignationCreate } from "./Create";
import { DesignationEdit } from "./Edit";
import { DesignationList } from "./List";

export const designations = {
  list: withRBAC(DesignationList, "view_hr"),
  create: withRBAC(DesignationCreate, "manage_hr"),
  edit: withRBAC(DesignationEdit, "manage_hr"),
  recordRepresentation: "title",
};
